import type { HistoryPoint } from "../lib/api";

type Props = { points: HistoryPoint[]; metric: "temperature" | "precipitation" };

export function TrendChart({ points, metric }: Props) {
  if (points.length < 2) return <div className="chart-empty">Lo storico comparirà dopo almeno due rilevazioni programmate.</div>;
  const width = 620, height = 170, pad = 20;
  const values = points.map((point) => metric === "temperature" ? point.temperatureMax : point.precipitation);
  const min = Math.min(...values), max = Math.max(...values);
  const range = max - min || 1;
  const path = values.map((value, index) => {
    const x = pad + index * (width - pad * 2) / Math.max(1, values.length - 1);
    const y = height - pad - (value - min) / range * (height - pad * 2);
    return `${index ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  return (
    <div className="trend-chart" role="img" aria-label={`Andamento ${metric === "temperature" ? "della temperatura" : "delle precipitazioni"}`}>
      <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
        <path className="chart-area" d={`${path} L${width - pad},${height - pad} L${pad},${height - pad} Z`} />
        <path className="chart-line" d={path} />
      </svg>
      <div className="chart-range"><span>{min.toFixed(1)}{metric === "temperature" ? "°" : " mm"}</span><span>{max.toFixed(1)}{metric === "temperature" ? "°" : " mm"}</span></div>
    </div>
  );
}
